import {datetimeLocalValueCalculator} from 'shared/lib/datetimeLocalCalculator'

const scalarFieldMap = {
	nameRef: 'name',
	addressRef: 'address',
	contentRef: 'content',
	startingChipRef: 'starting_chip',
	regEndLevelRef: 'reg_end_level',
	earlyEndLevelRef: 'early_end_level',
	earlyChipRef: 'early_chip',
	addOnRef: 'add_on',
	addOnChipRef: 'add_on_chip',
	reEntryRef: 're_entry',
	maxEntryRef: 'max_entry',
	prizeTotalRef: 'prize_total',
	ticketNumberRef: 'ticket_number',
	publishedTicketNumberRef: 'published_ticket_number',
}

const normalizeValue = (value) => value ?? ''

const setRefValue = (ref, value) => {
	if (ref?.current) ref.current.value = normalizeValue(value)
}

const syncClonedEventFields = (eventData, refs) => {
	if (!eventData) return

	Object.entries(scalarFieldMap).forEach(([refName, fieldName]) => {
		setRefValue(refs[refName], eventData[fieldName])
	})

	setRefValue(
		refs.regDateRef,
		datetimeLocalValueCalculator(eventData.reg_date)
	)
	setRefValue(refs.dateRef, datetimeLocalValueCalculator(eventData.date))
}

export default syncClonedEventFields
